export const PRIMARY_YAT_SELECTION = 'primary-yat-select';
export const TWITTER_CONNECT = 'twitter-connect';
export const TWITTER_CONNECT_CONFIRM = 'twitter-connect-confirm';
export const TWITTER_CONNECT_ERROR = 'twitter-connect-error';
